module.exports = __webpack_public_path__ + "static/media/imf.5f80de94.png";